import "core-js/modules/esnext.json.parse.js";
import Sortable from 'sortablejs';
export default {
    components: {
        Sortable
    },
    props: {
        column: {
            type: Object,
            default: ()=>{}
        }
    },
    data () {
        return {
            isSave: false,
            usercolumn: JSON.parse(JSON.stringify(this.column || []))
        };
    },
    watch: {
        usercolumn: {
            handler () {
                this.$emit('userChange', this.usercolumn);
            },
            deep: true
        }
    },
    mounted () {
        this.usercolumn.length > 0 && this.rowDrop();
    },
    methods: {
        rowDrop () {
            const _this = this;
            const tbody = this.$refs.list.querySelector('ul');
            Sortable.create(tbody, {
                handle: ".move",
                animation: 300,
                ghostClass: "ghost",
                onEnd ({ newIndex, oldIndex }) {
                    const tableData = _this.usercolumn;
                    const currRow = tableData.splice(oldIndex, 1)[0];
                    tableData.splice(newIndex, 0, currRow);
                }
            });
        },
        backDefaul () {
            this.$emit('back', this.usercolumn);
        },
        save () {
            this.$emit('save', this.usercolumn);
        }
    }
};
